import CacheStore from 'bz-utilities/modules/stores/cached-map-store';
import { action, computed } from 'mobx';
import {
  DiscountApplyTo,
  type DiscountCodeWithDiscountValueDto,
  DiscountRestriction,
  DiscountStatus
} from 'tm3-core/api.dtos';
import { cache } from '..';

class DiscountCodesStore extends CacheStore<DiscountCodeWithDiscountValueDto> {
  constructor() {
    super('discountCodes');
  }

  @computed
  get ActiveDiscountCodes(): DiscountCodeWithDiscountValueDto[] {
    return this.All.filter(
      (d) =>
        d.status === DiscountStatus.Active &&
        (!d.validTo || new Date(d.validTo) >= new Date()) &&
        (!d.validFrom || new Date(d.validFrom) <= new Date())
    );
  }

  @computed
  get ActiveDiscountCodesForDropdown() {
    return this.ActiveDiscountCodes.map((c) => {
      return {
        text: c.code,
        payload: c.id
      };
    });
  }

  @action.bound
  getDiscountCodesForConnectService(stockId?: string, restricted: boolean = false) {
    const stock = stockId ? cache.inventory.getByGuid(stockId) : undefined;
    return this.ActiveDiscountCodes.filter((c) => {
      if (!c.enableForConnect) return restricted;
      if (c.applyTo === DiscountApplyTo.Invoice) return !restricted;
      if (c.restriction === DiscountRestriction.None) return !restricted;
      if (stock) {
        if (c.restriction === DiscountRestriction.StockItems)
          return restricted === c.restrictedStockItems?.includes(stock.id);
        if (c.restriction === DiscountRestriction.Tags) {
          return restricted === c.restrictedTags?.some((tag) => stock.tags?.includes(tag));
        }
      }
      return !restricted;
    }).map((c) => ({
      text: c.code,
      payload: c.id
    }));
  }
}

export default DiscountCodesStore;
